import { useSelector } from 'react-redux';
import { Switch } from 'react-router-dom';

import selectLocked from 'selectors/selectLocked';
import selectLockEnabled from 'selectors/selectLockEnabled';
import { selectLockToken } from 'selectors/simple';
import { isEnvTest } from 'utils/env/determine.util';
import logger from 'utils/logger.util';

const L = logger('PinLock');

const PinLock = ({ hasSwitch, children }) => {
  const hasToken = useSelector(selectLockToken);
  const locked = useSelector(selectLocked);
  const lockEnabled = useSelector(selectLockEnabled);
  // FIXME: write better tests that don't depend on BE to make this one go away
  const notTestingEnv = !isEnvTest();
  L.debug('()', { locked, lockEnabled, hasToken, notTestingEnv });

  if (notTestingEnv && lockEnabled === null) {
    L.debug('()', 'Empty because:', { lockEnabled, notTestingEnv });
    return null;
  }

  const shouldDisplayForm = locked === true || (lockEnabled === true && !hasToken);
  if (shouldDisplayForm) {
    L.debug('()', 'Empty because:', { shouldDisplayForm, locked, lockEnabled, hasToken });
    return null;
  }

  if (notTestingEnv && !hasToken) {
    L.debug('()', 'Empty because:', { hasToken, notTestingEnv });
    return null;
  }

  // NOTE: some children have issues being re-rendered, fix them before using PinLock on them

  return hasSwitch ? <Switch>{children}</Switch> : <>{children}</>;
};

export default PinLock;
